import "@/i18n/config";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import { Pagination } from "@/client_app/components/Pagination";
import { getJobs } from "@/organization_app/features/jobs/services/FetchAPIService";

const limit = 25;

export function JobsPage() {
  const navigate = useNavigate();

  const [paginationOffset, setPaginationOffset] = useState(0);

  const queryParams = {
    limit: limit,
    offset: paginationOffset,
  };

  const { data, isFetching, isSuccess, error } = useQuery(
    ["jobs", queryParams],
    () =>
      getJobs(queryParams).then((response) => {
        return response.json();
      })
  );

  if (error) {
    return <div>Error!</div>;
  }
  const jobs = data?.jobs || [];
  const totalCount = data?.total_count || 0;
  return (
    <div className='text-legacyColor-neutral-1-500'>
      <header className='px-12 py-8 bg-legacyColor-neutral-2-100'>
        <h1 className='text-headline2 mb-4'>Jobs</h1>
      </header>
      <section className='m-12'>
        {isFetching && <div>Loading...</div>}

        {!isFetching && isSuccess && (
          <div>
            {jobs.length === 0 && "No data"}
            {jobs.length > 0 && (
              <>
                <table className='border border-gray-300 mb-4'>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "25%" }} />
                  </colgroup>
                  <thead>
                    <tr className='h-10 bg-gray-100 uppercase text-left'>
                      <th className='pl-4'>Name</th>
                      <th className='pl-4'>Opened at</th>
                      <th className='pl-4'>Job Posts</th>
                      <th className='pl-4'>Applications</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobs.map((job, index) => (
                      <tr
                        className='border-gray-300 border-t cursor-pointer'
                        key={index}
                        onClick={() =>
                          navigate({
                            pathname: `/admin/jobs/${job["id"]}/job_applications`,
                          })
                        }
                      >
                        <td className='p-4' style={{ verticalAlign: "top" }}>
                          <div className='text-md font-semibold'>
                            {job["name"]}
                          </div>
                        </td>

                        <td className='p-4' style={{ verticalAlign: "top" }}>
                          {new Date(job["opened_at"]).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>

                        <td className='p-4' style={{ verticalAlign: "top" }}>
                          {job["nb_job_posts"]}
                        </td>

                        <td className='p-4' style={{ verticalAlign: "top" }}>
                          {job["nb_applications"]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Pagination
                  totalCount={totalCount}
                  onPageChange={(data) => setPaginationOffset(data)}
                  perPage={limit}
                />
              </>
            )}
          </div>
        )}
      </section>
    </div>
  );
}
